// @ts-ignore
export const handleSelection = (toolbarPosition, setToolbarPosition, parentRef) => {
  const selection = window.getSelection();

  if (selection && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    const parentRect = parentRef?.current?.getBoundingClientRect();

    // Debugging logs
    console.log("Range selected:", rect);
    console.log("Parent ref:", parentRef?.current);
    console.log("Parent rect:", parentRect);

    if (!parentRect) {
      console.warn("Parent reference is missing or invalid.");
      return;
    }

    // Check if text is highlighted
    if (!range.collapsed) {
      setToolbarPosition({
        top: rect.top - parentRect.top - 40, // Relative to parent
        left: rect.left - parentRect.left,  // Relative to parent
        visible: true,
      });
      console.log("Toolbar position updated:", {
        top: rect.top - parentRect.top - 40,
        left: rect.left - parentRect.left,
        visible: true,
      });
    } else {
      setToolbarPosition({ ...toolbarPosition, visible: false });
      console.log("No selection: toolbar hidden");
    }
  }
};
